/* eslint-disable */
import store from '@/store'

export default {
  name: 'admin-departments',
  data: () => {
    return {
    }
  },

  created() {
  },
  computed: {
  },
  methods: {

  }
}
